module.exports = __webpack_public_path__ + "img/asus-zenfone4.bf2bf2b1.jpg";